import React from 'react'
import Header from '../Layout/Header'
import HomeSection from './HomeSections/HomeSection'
import Footer from '../Layout/Footer'

export default function Home() {
  return (
    <div>
      <Header />
      <HomeSection />
      <Footer />
    </div>
  )
}

